<template>
	<div id="loginPage" class="wrap">
		<div class="container">
			<div v-loading="loginLoad" element-loading-text="登录中..." class="loginContent">
				<h3 class="title ml20">校餐卫士后台登录</h3>
				<el-form :model="loginForm" class="no-star" :rules="formRules" ref="loginForm" label-position="left"
					label-width="70px">
					<el-form-item label="用户名" prop="loginName">
						<el-input type="text" v-model="loginForm.loginName" placeholder="请输入用户名" @keyup.enter.native="submitForm('loginForm')"></el-input>
					</el-form-item>
					<el-form-item label="密码" prop="password">
						<el-input type="password" v-model="loginForm.password" placeholder="请输入密码" @keyup.enter.native="submitForm('loginForm')"></el-input>
					</el-form-item>
            <el-button type="primary" round @click="submitForm('loginForm')">登录</el-button>
				</el-form>
			</div>
		</div>
		<div v-if="this.screenHeight>720" class="copyright">©️成都顺点科技有限公司</div>
	</div>
</template>
<script>
	import * as user from '@/api/user'
	import * as storage from "@/utils/sessionStorage";
	import { setLogin } from "@/router";
	export default {
		data() {
			return {
        loginLoad: false,
        isLoading: false,
        screenHeight: '',
				identifyImg: '',
				loginForm: {
          loginName: storage.getLocalData('loginName') ? storage.getLocalData('loginName') : '',
					password: ''
				},
				formRules: {
					loginName: [{
						required: true,
						message: '请输入正确的用户名',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '请输入正确的密码',
						trigger: 'blur'
					}]
				},
        userName: '',
        permissions: []
			}
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
            this.loginLoad = true;
						user.login(this.loginForm).then(r => {
								if (r.code === 200) {
                  setLogin(true);
                  this.$store.dispatch('getUserInfo', r.data);
                  // 登录页记住上一次登录的账号
                  storage.setLocalData('loginName', this.loginForm.loginName);
                  // 右上角个人信息记住当前登录账号的用户名(realName), 防止刷新页面, 或关闭页面再重新打开后, 用户名不显示
                  storage.setLocalData('userName', this.$store.state.user.realName);
                  this.$router.push({name: 'FoodList'})
                }
                this.loginLoad = false;
							}).catch((e) => {this.loginLoad = false});
					} else {
						console.log('信息错误!');
						return false;
					}
				});
			}
		},
		mounted() {
      this.screenHeight = document.body.clientHeight;
      window.onresize = () => {
          return (() => {
            this.screenHeight = document.body.clientHeight;
          })();
      };
			if (storage.getCookie('is-login') == true) {//判断已登录跳转
				this.$router.push({ path: '/', });
      }
    },
    watch: {
      screenHeight(val){
        this.screenHeight = val
      }
    }
    }
</script>
<style lang="scss" scoped>
	#loginPage {
    background: url("../assets/login.jpg") no-repeat center center;
		background-size: cover;
		width: 100%;
		height: 100%;
		.container {
			width: 1200px;
			height: 600px;
      position: relative;
      left: calc((100% - 600px) / 2);
      top: calc((100% - 600px) / 2);
			.loginContent {
				box-shadow: 0px 2px 4px 0px rgba(221, 221, 221, 0.5);
				background-color: #FFFFFF;
				border-radius: 20px;
				width: 600px;
				height: 400px;
				float: left;
				.title {
					margin-top: 60px;
					text-align: center;
					font-size: 24px;
					color: #178CFA;
				}
				.el-form {
					margin-top: 60px;
					.el-form-item {
						width: 400px;
						margin-left: 100px;
						margin-top: 30px;
					}
					.el-button {
						margin-top: 30px;
						width: 400px;
						height: 40px;
						margin-bottom: 0;
						font-size: 16px;
					}
					.identify {
						.identify-code {
							float: right;
							width: 110px;
							height: 40px;
              img {
                border-radius: 2px;
              }
						}
					}
				}
			}
		}
		.copyright {
			width: 100%;
			font-size: 12px;
			text-align: center;
      bottom: 40px;
			position: absolute;
			color: #606871;
		}
	}
</style>